import { createFileRoute } from '@tanstack/react-router';
import { Privacy } from '@/app/privacy/Privacy.page';

export const Route = createFileRoute('/datenschutz')({
    component: Privacy,
});

